export type BrowserSupportResult = {
  supported: boolean;
  message?: string;
};

const supportedBrowsersMessage =
  '当前浏览器不支持本系统所需的加密能力，请使用 Firefox 130+、Microsoft Edge 133+、Google Chrome 133+ 或 Safari 17+，以获得完整功能和更好的安全体验。';

let browserSupportPromise: Promise<BrowserSupportResult> | null = null;

async function canGenerateX25519Key() {
  if (typeof window === 'undefined') return false;
  if (!window.crypto?.subtle || typeof window.crypto.getRandomValues !== 'function') {
    return false;
  }
  try {
    const pair = await window.crypto.subtle.generateKey(
      { name: 'X25519', namedCurve: 'X25519' },
      true,
      ['deriveBits'],
    );
    if (pair && 'privateKey' in pair) {
      return true;
    }
    return false;
  } catch {
    return false;
  }
}

export function checkBrowserSupport() {
  browserSupportPromise ??= (async () => {
    const supported = await canGenerateX25519Key();
    return supported
      ? { supported: true }
      : { supported: false, message: supportedBrowsersMessage };
  })();
  return browserSupportPromise;
}

export { supportedBrowsersMessage };
